import script from "./BrandIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandIndex.vue?vue&type=script&setup=true&lang=js"

import "./BrandIndex.vue?vue&type=style&index=0&id=f17ea4b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f17ea4b4"]])

export default __exports__